import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(advancedFormat);
const formatTypeToString: any = {
  datetime: 'MMMM DD, YYYY HH:mm:ss',
  date: 'MMMM DD, YYYY',
  time: 'HH:mm:ss'
};
export const dateFormat = (
  date: string | number | dayjs.Dayjs | Date | null | undefined,
  format?: 'datetime' | 'date' | 'time' | string
): string => {
  return dayjs(date).format(formatTypeToString[format || 'date'] || format);
};

dayjs.extend(isSameOrBefore);

export const isSameOrBeforeDate = (date: Date, compareDate: Date): boolean => {
  return dayjs(date).isSameOrBefore(dayjs(compareDate));
};

export const isBeforeToday = (date: Date): boolean => {
  return isSameOrBeforeDate(date, dayjs().subtract(1, 'day').toDate());
};
